/**
 * Endpoint to send 1DS telemetry events to. Includes pubic and special environments endpoints.
 */
export enum OneDSEndpoint {
  /**
   * US Department of Defense endpoint (Pathfinder)
   */
  USGOV_DOD = 'https://pf.events.data.microsoft.com/OneCollector/1.0/',
  /**
   * US Department of Justice endpoint (Trailblazer)
   */
  USGOV_DOJ = 'https://tb.events.data.microsoft.com/OneCollector/1.0/',
  /**
   * Public endpoint
   */
  PUBLIC = 'https://browser.events.data.microsoft.com/OneCollector/1.0/'
}
